import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { 
    Box, Fab,
} from '@mui/material';
import { 
    newSociety,
    fetchSociety
 } from '../../../store/actions/userAction'
import { EditRounded } from '@mui/icons-material';
import SocietyForm from './SocietyForm';
import TitleWithEndAction from '../../common/TitleWithEndAction';
import FacturePreview from './FacturePreview';


class Society extends Component {
    state = { 
        openForm: false,
    }
    // componentDidMount = async () => {
    //     if(isEmpty(this.props.SOCIETY)){
    //         await this.props.fetchSociety()
    //         this.setState({
    //             society: this.props.SOCIETY
    //         })
    //     }
    // }

    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        
        this.setState({
            ...this.state,
            society:{
                ...this.state.society,
                [name]: value

            }
        })
    }
    
    render() {
        console.log('=============SOCIETY=======================');
        console.log(this.props.SOCIETY);
        console.log('====================================');
        return (
            <Box>
                {this.state.openForm && 
                    <SocietyForm 
                        handleClose={() => this.setState({ openForm: false})}
                        newSociety={this.props.newSociety}
                        STATE={this.props.STATE}
                        SOCIETY={this.props.SOCIETY}
                        notif={this.props.notif}
                    />
                }
                <TitleWithEndAction
                    title={"Infos de l'entreprise"}
                    // action={() => this.props.openFormDownload("/extract/equipements")}
                    // actionTitle="Télécharger" 
                    // disabled={this.props.downloading}
                >
                    <Fab 
                        color={"secondary"} 
                        onClick={() => this.setState({ openForm: true })} 
                        title="Modifier les infos"
                        size="small"
                    >
                        <EditRounded />
                    </Fab>
                </TitleWithEndAction>
                    <FacturePreview />
                    {/* <RemisePreview 
                        society={this.props.SOCIETY}
                        user={{}}
                        loan={{}}
                    /> */}
            </Box>
        );
    }
}

function mapStateToProps(state){
    return { 
        STATE: state.request,
        SOCIETY: state.society
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        newSociety,
        fetchSociety
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Society);




